import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { DocumentationService } from 'app/modules/vehicle-inventory/services/documentation.service';
import { Rest } from 'app/rest/rest_client';
import { UserService } from 'app/rest/user.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';

@Component({
    selector: 'app-doc-driver-license',
    templateUrl: './doc-driver-license.component.html',
    styleUrls: ['./doc-driver-license.component.css'],
    standalone: false
})
export class DocDriverLicenseComponent extends EntityFormComponent<Rest.InvDocument> implements OnInit {

  @Input() isNew: boolean;
  @Input() driverLicense: Rest.InvDocument;

  @Input() file: any;
  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();
  constructor(
    private documentService: DocumentationService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
    public userService: UserService,

) {
    super(documentService, notificationsService, i18n, authenticationService);
}

  save(): void {
    var that = this;
    if(this.isNew){
      this.documentService.createDocument(JSON.stringify(this.driverLicense), this.file).then((response) => {
        that.notificationsService.add(Severity.success, "", this.translateService.instant('general.createSuccessfull'));
        that.closeDialog.emit();
      }).catch((error) => {
        that.notificationsService.add(Severity.error, "", this.translateService.instant('general.createError'));
      });
    }else{
      this.documentService.updateDocument(JSON.stringify(this.driverLicense), this.file).then((response) => {
        that.notificationsService.add(Severity.success, "", this.translateService.instant('general.updateSuccessfull'));
        that.closeDialog.emit();
      }).catch((error) => {
        that.notificationsService.add(Severity.error, "", this.translateService.instant('general.updateError'));
      });
    }

  }

}
